<!DOCTYPE html>
<html>

<head>
    <!-- Seus metadados, links para estilos e scripts aqui -->
</head>

<body>
    <div class="container">

    </div>
</body>

</html>